/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2020
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import MoserObject from './MoserObject';
import SortOrder from './SortOrder';
import SortOrderNullPlacement from './SortOrderNullPlacement';
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
//@import com/ibm/bi/platform/moser/common/generated/metadata/SortOrder (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/SortOrderNullPlacement (runtime) // new

/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="useExpression" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="displayExpression" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="sortExpression" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="direction" type="{}sortOrder" minOccurs="0"/&gt; &lt;element name="nullPlacement" type="{}sortOrderNullPlacement" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class QueryValueSelector extends MoserObject{

	useExpression = null;

	displayExpression = null;

	sortExpression = null;



	/**
	 * Gets the value of the useExpression property.
	 * @return {String} possible object is {@link String}
	 */
	getUseExpression() {
		return this.useExpression;
	}

	/**
	 * Sets the value of the useExpression property.
	 * @param {String} value allowed object is {@link String}
	 */
	setUseExpression(value) {
		var oldValue = this.useExpression;
		this.useExpression = value;
		this._setAndNotify(30, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the displayExpression property.
	 * @return {String} possible object is {@link String}
	 */
	getDisplayExpression() {
		return this.displayExpression;
	}

	/**
	 * Sets the value of the displayExpression property.
	 * @param {String} value allowed object is {@link String}
	 */
	setDisplayExpression(value) {
		var oldValue = this.displayExpression;
		this.displayExpression = value;
		this._setAndNotify(31, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the sortExpression property.
	 * @return {SortExpression} possible object is {@link QueryValueSelector.SortExpression}
	 */
	getSortExpression() {
		return this.sortExpression;
	}

	/**
	 * Sets the value of the sortExpression property.
	 * @param {SortExpression} value allowed object is {@link QueryValueSelector.SortExpression}
	 */
	setSortExpression(value) {
		var oldValue = this.sortExpression;
		this.sortExpression = value;
		this._setAndNotify(32, oldValue, value, true, false);
	}

	/**
	 * Creates a new instance of <code>QueryValueSelector</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> QueryValueSelector</code> object from.
	 * @return {QueryValueSelector} an object of type <code>QueryValueSelector</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createQueryValueSelector();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "QueryValueSelector";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 30, "useExpression", null));
		featureList.push(this.createFeature(false, false, false, 31, "displayExpression", null));
		var clazz;
		if (factory) {
			clazz = factory.createQueryValueSelectorSortExpression().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 32, "sortExpression", clazz));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 30:
			this.setUseExpression((value));
			break;
		case 31:
			this.setDisplayExpression((value));
			break;
		case 32:
			this.setSortExpression((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 30:
			return this.getUseExpression();
		case 31:
			return this.getDisplayExpression();
		case 32:
			return this.getSortExpression();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 30:
			return this.getUseExpression();
		case 31:
			return this.getDisplayExpression();
		case 32:
			return this.getSortExpression();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}
/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="direction" type="{}sortOrder" minOccurs="0"/&gt; &lt;element name="nullPlacement" type="{}sortOrderNullPlacement" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
QueryValueSelector.SortExpression = class extends MoserObject{

	direction = null;

	nullPlacement = null;



	/**
	 * Gets the value of the direction property.
	 * @return {SortOrder} possible object is {@link SortOrder}
	 */
	getDirection() {
		return this.direction;
	}

	/**
	 * Sets the value of the direction property.
	 * @param {SortOrder} value allowed object is {@link SortOrder}
	 */
	setDirection(value) {
		var oldValue = this.direction;
		this.direction = value;
		this._setAndNotify(119, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the nullPlacement property.
	 * @return {SortOrderNullPlacement} possible object is {@link SortOrderNullPlacement}
	 */
	getNullPlacement() {
		return this.nullPlacement;
	}

	/**
	 * Sets the value of the nullPlacement property.
	 * @param {SortOrderNullPlacement} value allowed object is {@link SortOrderNullPlacement}
	 */
	setNullPlacement(value) {
		var oldValue = this.nullPlacement;
		this.nullPlacement = value;
		this._setAndNotify(40, oldValue, value, false, false);
	}

	/**
	 * Creates a new instance of <code>SortExpression</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> SortExpression</code> object from.
	 * @return {SortExpression} an object of type <code>SortExpression</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createQueryValueSelectorSortExpression();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "SortExpression";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, true, false, 119, "direction", SortOrder));
		featureList.push(this.createFeature(false, true, false, 40, "nullPlacement", SortOrderNullPlacement));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 40:
			this.setNullPlacement((value));
			break;
		case 119:
			this.setDirection((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 40:
			return this.getNullPlacement();
		case 119:
			return this.getDirection();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 40:
			return this.getNullPlacement();
		case 119:
			return this.getDirection();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/QueryValueSelector.js